<template>
    <div class="inner clearfix">
        <div class="xs-left fl">
            <div class="chart-con">
                <IconTitle :title="'各领域会议数量分布'" :iconName="'lunwen'"/>
                <div class="chart" id="chart1"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'各领域参会人员数量'" :iconName="'people'"/>
                <div class="chart" id="chart2"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'学术会议论文被收录的比例情况'" :iconName="'jishiben'"/>
                <div class="chart" id="chart3"></div>
            </div>
        </div>
        <div class="xs-center fl">
            <div class="chart-con">
                <IconTitle :title="'会议举办城市'" class="lg" :iconName="'huiyuandiyu'"/>
                <div class="chart map" id="chart4"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'会议举办时间分布'" class="lg" :iconName="'lingyuhuiyi'"/>
                <div class="chart" id="chart5"></div>
            </div>
        </div>
        <div class="xs-right fl">
            <div class="chart-con">
                <IconTitle :title="'各领域会议创办至今总计届次'" :iconName="'huiyichuangban'"/>
                <div class="chart" id="chart6"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'各领域会议举办天数'" :iconName="'time'"/>
                <div class="chart" id="chart7"></div>
            </div>
            <div class="chart-con">
                <IconTitle :title="'各领域会议举办国家'" :iconName="'quanqiu'"/>
                <div class="rink-con">
                    <div class="estimate_header clearfix">
                        <span>国家</span>
                        <span>参会人数</span>
                    </div>
                    <div class="estimate_body" ref="estimateList">
                        <div>
                            <dl v-for="(item,index) in countryData.column" :key="index">
                                <dd>
                                    {{ item }}
                                </dd>
                                <dd>
                                    {{ countryData.data[index] }}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import IconTitle from '@/components/icontitle';

    import {
        getMeetCount,
        getParticipants,
        getTotalSessions,
        getIncludedProportion,
        getMeetTime,
        getMeetingDays,
        getHostCountry,
        map
    } from '@/assets/scripts/api/xsjl';
    const BASE_FONT_COLOR = '#B5C8FF';
    const LINE_COLOR = '#344ED5';
    const lineColor = '#2F46C1';
    const labelColor = '#B5C8FF';
    const lineChartColor2 = ['#FB058F', '#00CCFF'];
    const barColor = ['#344DD5', '#00CCFF'];
    const mapColor = ['#8592FF', '#6978FF', '#4E60F9', '#384DDF', '#293FCA', '#1831B2'];

    export default {
        name: 'ZhongYaoXueShuHuiYi',
        components: {
            IconTitle
        },
        data() {
            return {
                countryData: []
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

                // 各领域会议数量分布
                getMeetCount().then(({data}) => {
                    this.initChart1(data);
                })

                // 各领域参会人员数量
                getParticipants().then(({data}) => {
                    this.initChart2(data);
                })

                // 各领域会议创办至今总计届次
                getTotalSessions().then(({data}) => {
                    this.initChart6(data);
                })
                // 学术会议论文被收录的比例情况
                getIncludedProportion().then(({data}) => {
                    this.initChart3(data);
                })
                // 会议举办时间分布
                getMeetTime().then(({data}) => {
                    this.initChart5(data);
                })
                // 各领域会议举办天数
                getMeetingDays().then(({data}) => {
                    this.initChart7(data);
                })
                // 会议举办国家
                getHostCountry().then(({data}) => {

                    this.countryData = data;
                    this.$nextTick(() => {
                        this.$scrollTable(this.$refs.estimateList);
                    });

                })

                // 地图
                map().then(({data}) => {
                    this.initChart4(data);
                })
            },
            initChart1(data){
                const chart = echarts.init(document.getElementById("chart1"));

                chart.setOption(this.initRadarCharts(data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2(data){
                const chart = echarts.init(document.getElementById("chart2"));
                chart.setOption(this.initRadarCharts(data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart3(data){
                const chart = echarts.init(document.getElementById("chart3"));

                chart.setOption(this.initBarCharts(data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4(data){
                const chart = echarts.init(document.getElementById("chart4"));
                const option = this.getMapOption(data);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5(data){
                const chart = echarts.init(document.getElementById("chart5"));
                const option = this.getLineOption(data);

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart6(data){
                const chart = echarts.init(document.getElementById("chart6"));

                chart.setOption(this.initBarCharts(data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart7(data){
                const chart = echarts.init(document.getElementById("chart7"));

                chart.setOption(this.initBarCharts(data), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initRadarCharts(data) {
                let indicatorData = this.getchartData(data),
                    option = {};
                let seriesData = data.list.map((item, index) => {
                    return {
                        type: 'radar',
                        name: data.title[index],
                        data: [item],
                        symbolSize: 8,
                        lineStyle: {
                            color: lineChartColor2[index]
                        },
                        areaStyle: {
                            color: lineChartColor2[index],
                            opacity: 0.5
                        },
                        itemStyle: {
                            color: lineChartColor2[index],
                            borderWidth: 2
                        }
                    }
                })

                option = {
                    tooltip: {
                        show: true,
                        trigger: 'item'
                    },
                    radar: {
                        radius: '60%',
                        splitNumber: 2,
                        axisLine: {
                            lineStyle: {
                                color: LINE_COLOR
                            }
                        },
                        splitArea: false,
                        splitLine: {
                            lineStyle: {
                                color: LINE_COLOR
                            }
                        },
                        name: {
                            textStyle: {
                                color: BASE_FONT_COLOR,
                                padding: [3, 5]
                            }
                        },
                        indicator: indicatorData
                    },
                    series: seriesData
                };

                return option;
            },
            getchartData(data) {
                let indicatorData = [];

                let numData = data.list.map((item) => {
                    return Math.max.apply(null, item);
                })

                data.column.forEach((item) => {
                    let max = Math.max.apply(null, numData),
                        obj = {
                            name: item,
                            max: max
                        };

                    indicatorData.push(obj);
                });

                return indicatorData;
            },
            initBarCharts(data) {
                let option,
                    seriesData = [],
                    lengendData = [];

                if (data.list && data.list.length) {

                    data.list.forEach((item, index) => {
                        seriesData.push({
                            type: 'bar',
                            barWidth: '10',
                            barGap: '10%',
                            name: data.title[index],
                            itemStyle: {
                                normal: {
                                    show: true,
                                    color: barColor[index]
                                }
                            },
                            data: item
                        });

                        lengendData.push({
                            name: data.title[index],
                            icon: 'rect',
                            textStyle: {
                                color: labelColor,
                                margin: 7
                            }
                        })
                    });
                }
                option = {
                    color: barColor,
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        top: '5%',
                        right: 0,
                        itemWidth: 11,
                        itemHeight: 11,
                        padding: [0, 15],
                        textStyle: {
                            color: '#B5C8FF',
                            fontSize: 14
                        },
                        data: lengendData
                    },
                    grid: {
                        left: '0',
                        right: '0',
                        top: '20%',
                        bottom: '10%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                            margin: 17,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        axisTick: {
                            alignWithLabel: true
                        },
                        data: data.column
                    },
                    yAxis: {
                        nameTextStyle: {
                            color: '#8CC1FF'
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: lineColor,
                                type: 'dotted'
                            }
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: labelColor,
                                fontSize: 12
                            },
                            formatter: '{value} %'
                        }
                    },
                    series: seriesData
                };

                return option;
            },
            getLineOption(data){
                let option,
                    seriesData = [],
                    lengendData = [];

                data.list.forEach((item, index) => {

                    seriesData.push({
                        type: 'line',
                        smooth: true,
                        symbol: 'circle',
                        symbolSize: 6,
                        name: data.title[index],
                        itemStyle: {
                            normal: {
                                color: lineChartColor2[index],
                                lineStyle: {
                                    color: lineChartColor2[index],
                                }
                            }
                        },
                        data: item
                    });

                    lengendData.push({
                        name: data.title[index],
                        icon: 'circle',
                        textStyle: {
                            color: labelColor,
                            margin: 7
                        }
                    })
                });

                option = {
                    legend: {
                        align: 'left',
                        position: 'center',
                        itemWidth: 6,
                        itemHeight: 6,
                        itemGap: 20,
                        bottom: 0,
                        data: lengendData
                    },
                    grid: {
                        left: '0',
                        top: '11%',
                        bottom: '13%',
                        right: '0',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                    },
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            show: true,
                            margin: 12,
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        axisTick: {
                            show: true,
                            alignWithLabel: true,
                            lineStyle: {
                                color: lineColor,
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: lineColor
                            }
                        },
                        data: data.column
                    },
                    yAxis: {
                        scale: false,
                        nameTextStyle: {
                            color: labelColor
                        },
                        axisTick: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            formatter: '{value}',
                            textStyle: {
                                color: labelColor,
                                fontSize: 14
                            }
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: seriesData
                };

                return option;

            },
            getMapOption(data) {
                let option = {};
                let valData = [];
                let mapData = data.map((item) => {
                    valData.push(item.count)
                    return {
                        value: item.count,
                        name: item.name
                    };
                });

                option = {
                    tooltip: {
                        triggerOn: "mousemove",
                        formatter: function (params) {
                            var a = '<span>' + params.name + '</span>';
                            var b = '<span>' + params.value + '</span>';
                            return [a, b].join(' :  ');
                        },
                        backgroundColor: 'rgba(29, 38, 71)',
                    },
                    geo: {
                        show: true,
                        map: 'china',
                        zoom: 1,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#090D28',
                                borderWidth: 1,
                                areaColor: '#8592FF',
                                shadowColor: 'rgba(133,146,255,.3)',
                                shadowBlur: 50
                            },
                            emphasis: {
                                areaColor: '#4E60F9'
                            }
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(null, valData),
                        show: false,
                        calculable: false,
                        inRange: {
                            color: mapColor
                        }
                    },
                    series: [{
                        type: 'map',
                        geoIndex: 0,
                        data: mapData
                    }]
                };

                return option;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/common.scss";

    .inner {
        padding: 1% 2%;
        .map {
            position: relative;
            background: url('~@/assets/images/mapbg.png') no-repeat 5px 42px / auto 18.8%;

            &:after {
                display: inline-block;
                content: '';
                width: 83.77%;
                height: 9.875%;
                background: url('~@/assets/images/mapline.png') no-repeat center center / 100% 100%;
                @include position(absolute, auto, auto, 5.49%, 50%);
                transform: translateX(-50%);
            }
        }
    }

    .xs {
        &-left,
        &-right {
            width: 24.72%;
            height: 98%;
            overflow: hidden;
            .chart-con {
                height: calc(100% / 3);
            }
            .chart {
                height: calc(100% - 0.4rem);
            }
        }
        &-right {
            .rink-con {
                margin-top: 0.23rem;
                border: 1px solid #17215F;
                height: calc(100% - 0.63rem);
                .estimate_header {
                    span {
                        float: left;
                        width: calc(100% / 2);
                        height: 0.44rem;
                        text-align: center;
                        border-right: 1px solid #080B26;
                        font-size: 0.14rem;
                        line-height: 0.44rem;
                        color: #E7F0FC;
                        background: #1B276D;
                    }
                }
                .estimate_body {
                    height: calc(100% - 0.48rem);
                    overflow-y: hidden;

                    dl {
                        overflow: hidden;
                        background: #080B26;
                        &:nth-child(2n) {
                            background: #141D51;
                        }
                    }
                    dd {
                        float: left;
                        width: calc(100% / 2);
                        height: 0.44rem;
                        line-height: 0.44rem;
                        font-size: 0.16rem;
                        text-align: center;
                        border: 1px solid #090C26;
                        color: #B5C8FF;
                        border-right: 0;
                        padding: 0 2%;
                        @include text-ellipsis;
                    }
                }
            }
        }
        &-center {
            width: 47.56%;
            margin: 0 1.5%;
            height: 98%;
            .chart-con {
                height: 67%;
                &:nth-child(2) {
                    height: 33%;
                }
                .chart {
                    height: calc(100% - 0.4rem);
                }
            }
        }
    }
</style>